/**
 * @generated SignedSource<<10498bfd792c3fe19f45a1caf54c3439>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedEditorialModule_componentModule$data = {
  readonly cmsDisplayTitle: string | null;
  readonly items: ReadonlyArray<{
    readonly cmsId: number | null;
    readonly linkData: {
      readonly path: string | null;
    };
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedEditorialModuleItem_item">;
  } | null> | null;
  readonly " $fragmentType": "HpSharedEditorialModule_componentModule";
};
export type HpSharedEditorialModule_componentModule$key = {
  readonly " $data"?: HpSharedEditorialModule_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedEditorialModule_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedEditorialModule_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cmsDisplayTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EditorialItem",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cmsId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedEditorialModuleItem_item"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EditorialModule",
  "abstractKey": null
};

(node as any).hash = "907bb56dab72ce6af9ef7c999ec4d722";

export default node;
